<mat-card>
  <mat-card-content>
    <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="disabled">
      {{ submitOverride || 'INBOX.SAVE' | translate }}
    </button>
    <a mat-stroked-button *ngIf="cancelLink" [routerLink]="[cancelLink]">
      {{ cancelOverride || 'INBOX.CANCEL' | translate }}
    </a>
  </mat-card-content>
</mat-card>
